import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  container: {
    backgroundColor: theme.COLOR_BG_BASE, // color dark-light theme verified
    flex: 1,
    justifyContent: 'space-between',
    paddingBottom: rh(24),
  },
  topBlock: {
    flex: 1,
    paddingHorizontal: rw(40),
    paddingTop: rh(32),
    rowGap: rh(40),
  },
  titleBlock: {
    rowGap: rh(12),
  },
  title: {
    color: theme.COLOR_TEXT_PRIMARY, // color dark-light theme verified
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rh(34),
  },
  subtitle: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
  },
  fieldBlock: {
    rowGap: rh(16),
  },
  inputRow: {
    alignItems: 'center',
    columnGap: rw(8),
    flexDirection: 'row',
  },
  codeBlock: {
    alignItems: 'center',
    columnGap: rw(8),
    flexDirection: 'row',
  },
  code: {
    color: theme.COLOR_TEXT_PRIMARY, // color dark-light theme verified
    fontSize: rf(20),
    letterSpacing: 0,
    lineHeight: rh(28.8),
  },
  numberRow: {
    alignItems: 'center',
    columnGap: rw(2),
    flexDirection: 'row',
  },
  placeholder: {
    color: theme.COLOR_TEXT_DISABLED, // color dark-light theme verified
    fontSize: rf(20),
    letterSpacing: 0,
    lineHeight: rh(28.8),
  },
  flagWrap: {
    borderRadius: rw(999),
    height: rh(28),
    overflow: 'hidden',
    width: rw(28),
  },
  error: {
    color: theme.COLOR_TEXT_CRITICAL,
    fontSize: rf(16),
    lineHeight: rh(22),
  },
  action: {
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
  },
}))
